import request from '@/utils/request'
import Cookies from 'js-cookie'
import axios from 'axios'

// ------------------------- 展示模板 -------------------------
export function traceTemplateList(params) {
  return request({ url: `/trace_templates/`, method: 'get', params })
}
export function traceTemplateCreate(data) {
  return request({ url: `/trace_templates/`, method: 'post', data })
}
export function traceTemplateUpdate(data) {
  return request({ url: `/trace_templates/${data.id}/`, method: 'put', data })
}
export function traceTemplateDestroy(data) {
  return request({ url: `/trace_templates/${data.id}/`, method: 'delete', data })
}

// ------------------------- 生码批次 -------------------------
export function traceBatchList(params) {
  return request({ url: `/trace_batches/`, method: 'get', params })
}
export function traceBatchCreate(data) {
  return request({ url: `/trace_batches/`, method: 'post', data })
}
export function traceBatchUpdate(data) {
  return request({ url: `/trace_batches/${data.id}/`, method: 'put', data })
}
export function traceBatchDestroy(data) {
  return request({ url: `/trace_batches/${data.id}/`, method: 'delete', data })
}
export function traceBatchNumber() {
  return request({ url: `/trace_batches/batch_number/`, method: 'get' })
}
export function traceBatchGenerate(id, data) {
  return request({ url: `/trace_batches/${id}/generate/`, method: 'post', data })
}

// 导出溯源码 Excel (Blob)
export function traceBatchExport(id) {
  return axios({
    url: `/api/trace_batches/${id}/export/`,
    headers: { Authorization: 'Bearer ' + Cookies.get('access') },
    responseType: 'blob',
    method: 'get',
  })
}

// 打包下载二维码 ZIP (Blob)
export function traceBatchQrcodes(id) {
  return axios({
    url: `/api/trace_batches/${id}/qrcodes/`,
    headers: { Authorization: 'Bearer ' + Cookies.get('access') },
    responseType: 'blob',
    method: 'get',
  })
}

// ------------------------- 溯源码 -------------------------
export function traceCodeList(params) {
  return request({ url: `/trace_codes/`, method: 'get', params })
}

// ------------------------- 扫码记录 -------------------------
export function scanRecordList(params) {
  return request({ url: `/scan_records/`, method: 'get', params })
}

// ------------------------- 统计 -------------------------
export function traceStatSummary(params) {
  return request({ url: `/trace_stats/summary/`, method: 'get', params })
}
export function traceStatRanking(params) {
  return request({ url: `/trace_stats/ranking/`, method: 'get', params })
}

// ------------------------- 图片上传 -------------------------
// 上传图片到后端服务器, 返回 { url, name }
export function traceImageUpload(file) {
  let data = new FormData()
  data.append('file', file)
  return axios({
    url: `/api/trace_upload/`,
    method: 'post',
    data,
    headers: {
      Authorization: 'Bearer ' + Cookies.get('access'),
      'Content-Type': 'multipart/form-data',
    },
  }).then(res => res.data)
}

// ------------------------- 公开扫码落地(免登录) -------------------------
export function traceScan(code) {
  return axios({
    url: `/api/t/${encodeURIComponent(code)}/`,
    method: 'get',
  }).then(res => res.data)
}
